'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const VERSION = "bb29b690";
const ZINNIA_STYLESHEET_URL = `https://design-system-css.zapier.com/design-system/${VERSION}.css`;
const ZinniaStylesheet = (props) => {
  return React__default.default.createElement("link", Object.assign({ href: ZINNIA_STYLESHEET_URL, rel: "stylesheet" }, props));
};

exports.ZINNIA_STYLESHEET_URL = ZINNIA_STYLESHEET_URL;
exports.ZinniaStylesheet = ZinniaStylesheet;
//# sourceMappingURL=ZinniaStylesheet.cjs.js.map
